// extracted by mini-css-extract-plugin
module.exports = {"select-dropdown":"ConfigurationModal_select-dropdown__2JhZR"};